import Utils from './Utils.js';

class TranslationService {

  constructor(placeholderService, translationMapper, httpService, requestBuilder) {

    this.placeholderService = placeholderService;
    this.translationMapper = translationMapper;
    this.httpService = httpService;
    this.requestBuilder = requestBuilder;

  }

  initialiseTranslationService() {

    let translationIds = this.translationMapper.getTranslationIds();

    let translationsRequest = this.requestBuilder.getTranslationsRequest(translationIds);

    this.translationMap = {};

    return this.httpService.post(translationsRequest)
      .then((response) => {
        response.data.forEach((currentValue) => {
          this.translationMap[this.translationMapper.getMapValue(currentValue.id)]
            = this.placeholderService.decorateString(currentValue.label);
        });
      });

  }

  get(translationId, placeholders) {

    if (Utils.stringIsInvalidOrEmpty(translationId)) {
      throw new Error('translationId is required and must be a non empty string');
    }

    if (!this.translationMap.hasOwnProperty(translationId)) {
      return `{{ ${translationId} }}`;
    }

    let translation = this.translationMap[translationId];
    if (placeholders !== undefined) {
      translation = decorateTranslationWithPlaceholders.bind(this)(translation, placeholders);
    }

    return translation;

  }

}

let decorateTranslationWithPlaceholders = function (translation, placeholders) {

  if (!Utils.inputIsObject(placeholders)) {
    throw new Error('placeholders must be an object');
  }

  for (let placeholder in placeholders) {
    translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), placeholders[placeholder]);
  }

  return translation;

};

export default TranslationService;
